import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/auth';
import { notificationsApi } from '@/api/endpoints';

/**
 * Live unread-notification count for the topbar bell.
 *
 * Polls the (already shipped) `/notifications?unread_only=true` endpoint every
 * 60s. We only ask for a single row — the count comes from the paginated
 * `total` field, so the payload stays tiny regardless of how many unread
 * notifications exist. The query is disabled until the user is authenticated
 * so we never fire an unauthenticated request that would 401 + redirect.
 */
export function useUnreadNotifications(): number {
  const isAuthenticated = useAuthStore((s) => Boolean(s.accessToken));

  const { data } = useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: () => notificationsApi.list({ page: 1, page_size: 1, unread_only: true }),
    enabled: isAuthenticated,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    // A failed count must never break the shell — treat errors as "no badge".
    retry: 1,
  });

  return data?.total ?? 0;
}
